<template>
  <div>
    <el-dialog
      ref="transferDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('transferDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="loadingText"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogTransferForm"
          :model="dialogTransferForm"
          :rules="dialogTransferFormRules"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              基础信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="12">
                  <el-form-item
                    label="管理人员(移出)"
                    prop="managerId"
                  >
                    <el-select
                      v-model="dialogTransferForm.managerId"
                      filterable
                      clearable
                      placeholder="请选择要移交的管理人员"
                      style="width:100%"
                      @change="managerChangeFun"
                    >
                      <el-option
                        v-for="item in managerOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="管理人员(接收)"
                    prop="toManagerId"
                  >
                    <el-select
                      v-model="dialogTransferForm.toManagerId"
                      filterable
                      clearable
                      placeholder="请选择要接收固定资产的管理人员"
                      style="width:100%"
                      @change="toManagerChangeFun"
                    >
                      <el-option
                        v-for="item in userOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>

          <div class="modal-box">
            <h3 class="modal-title">
              移交的固定资产清单
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-table
                    :data="manageFixedAssetData"
                    style="width: 100%; margin-bottom: 8px;"
                    :header-cell-style="{background:'#0076ff'}"
                    border
                  >
                    <el-table-column
                      type="index"
                      label="序号"
                      width="60"
                      align="center"
                    />
                    <el-table-column
                      prop="name"
                      label="资产名称"
                      header-align="center"
                    />
                    <el-table-column
                      prop="unit"
                      label="计量单位"
                      align="center"
                      width="100"
                    />
                    <el-table-column
                      prop="manageNumber"
                      label="管理数量"
                      align="center"
                      width="150"
                    />
                    <el-table-column
                      prop="lentNumber"
                      label="借出数量"
                      align="center"
                      width="150"
                    />
                    <el-table-column
                      prop="damageNumber"
                      label="损坏遗失数量"
                      align="center"
                      width="150"
                    />
                  </el-table>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          :disabled="operateButtonDisable"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>

// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 设置input值为数字
import setNumberMixin from '@/mixin/setNumberMixin'
// 数据请求
import { transferFixedAssetManagerApi, loadSelectManagerDataApi, loadManageFixedAssetDataApi } from '@/api/fixedAsset'
import { loadUserSelectDataByUserRegionIdsApi } from '@/api/user'

export default {
  components: {},
  mixins: [dialogDragMixin, setNumberMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    // 接收人员
    const validateToManager = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请选择要接收固定资产的管理人员'))
      } else if (this.dialogTransferForm.managerId && value === this.dialogTransferForm.managerId) {
        callback(new Error('移交固定资产和接收的人员不能是同一人'))
      } else {
        callback()
      }
    }
    return {
      operateButtonDisable: false,
      loading: false,
      loadingText: '努力加载数据中，请耐心等待',

      dialogTransferForm: {},
      dialogTransferFormRules: {
        managerId: [{ required: true, message: '请选择要移交出固定资产的管理人员', trigger: 'change' }],
        toManagerId: [{ required: true, validator: validateToManager, trigger: 'change' }],
      },
      managerOptions: [],
      userOptions: [],
      manageFixedAssetData: []
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        let _this = this
        _this.loading = true
        _this.loadingText = '努力加载数据中，请耐心等待'
        _this.operateButtonDisable = false

        _this.managerOptions = []
        _this.userOptions = []
        _this.manageFixedAssetData = []
        _this.dialogTransferForm = {
          managerId: '',
          toManagerId: '',
          toManagerName: ''
        }
        // 获取管理人员选项数据
        _this.initManagerSelectData()
        // 获取接收人员选项数据
        _this.initUserSelectData()

        _this.$nextTick(() => {
          _this.loading = false
          _this.$refs.dialogTransferForm.clearValidate()
        })
      }
    }
  },
  methods: {
    // 初始管理人员选项数据
    initManagerSelectData() {
      let _this = this;
      loadSelectManagerDataApi().then(response => {
        response.data.forEach(item => {
          _this.managerOptions.push({ label: item.managerName, value: item.managerId })
        })
      })
    },
    // 获取接收人员选项数据
    initUserSelectData() {
      let _this = this;
      loadUserSelectDataByUserRegionIdsApi().then(response => {
        response.data.forEach(item => {
          _this.userOptions.push({ label: item.name, value: item.id })
        })
      })
    },
    // 管理人员选择回调
    managerChangeFun(val) {
      let _this = this;
      _this.manageFixedAssetData = [];
      if (val) {
        loadManageFixedAssetDataApi({ managerId: val }).then(response => {
          _this.manageFixedAssetData = response.data || []
        })
      }
    },
    // 接收人员选择回调
    toManagerChangeFun(val) {
      let _this = this
      let selectedItem = {}
      if (val) {
        selectedItem = _this.userOptions.find(item => {
          return item.value === val
        })
      }
      _this.dialogTransferForm.toManagerName = selectedItem.label || ''
    },
    // 加载数据
    reloadData() {
      this.$emit('reloadData')
    },
    modalClose() {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
      this.$refs.dialogTransferForm.clearValidate()
    },
    // 新增|修改保存
    handleSave() {
      let _this = this
      _this.$refs.dialogTransferForm.validate(valid => {
        if (valid) {
          this.$confirm('是否确定移交固定资产到新的管理人员', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
            transferFixedAssetManagerApi(_this.dialogTransferForm).then(res => {
              _this.$message({ message: res.message, type: 'success' })
              _this.reloadData()
              _this.modalClose()
            }).catch(() => {
              _this.loading = false
              _this.operateButtonDisable = false
            })
          }).catch(() => { })
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.el-table--border {
  border-left: 1px solid #dfe6ec;
  margin-top: 5px;
}
::v-deep .el-table {
  th {
    color: #ffffff;
    .cell {
      line-height: 17px;
    }
    .caret-wrapper {
      height: 18px;
    }
    .sort-caret {
      border-width: 4px;
      &.ascending {
        top: 0;
      }
      &.descending {
        bottom: 0;
      }
    }
  }
  .ascending .sort-caret.ascending {
    border-bottom-color: #ffffff;
  }
  .descending .sort-caret.descending {
    border-top-color: #ffffff !important;
  }
}
::v-deep .el-table--mini th,
::v-deep .el-table--mini td {
  padding: 4px;
  font-size: 12px;
  .cell {
    line-height: 16px;
  }
}

::v-deep .el-table__row {
  .el-form-item__error {
    display: none;
  }
  .el-form-item--mini.el-form-item {
    margin-bottom: 0px;
  }
}
</style>
